

import React from 'react';
import ReactDOM from 'react-dom/client';

import {
createBrowserRouter,
RouterProvider,
} from "react-router-dom";

import './index.css';
import Home from './routes/Home/Home';
import reportWebVitals from './helper/reportWebVitals';
import BlogHome from './routes/Blog/BlogHome/BlogHome';

import CreateBlog from './routes/Blog/CreateBlog';

import 'bootstrap/dist/css/bootstrap.min.css';
import BlogType from './routes/Blog/BlogType/BlogType';
import BlogPost from './routes/Blog/BlogPost/BlogPost';


const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/",
    element: <BlogHome />,
  },
  {
    path: "/blog/create",
    element: <CreateBlog/>
  },
  {
    path: "/blog/:type",
    element: <BlogType/>
  },
  {
    path: "/blog/post/:id",
    element: <BlogPost/>
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'));

// Learning Point: StrictMode is a tool for highlighting potential problems in an application. 
// A side-effect of strict mode is that it 'double-mounts' components. This is done to ensure that no side-effects in the initial render pass cause issues with the final UI. 
// This is important to take note as it makes hooks (like useEffect) to run twice.
// That said, strict mode checks are run in development mode only; they do not impact the production build.

root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
